import { Navigate, Outlet } from "react-router";
import { getUserData } from "../components/reuse/getUserRole";

// функция проверки регистрирован ли пользователь проверка наличия сессионного ключа (получаем информацию о пользователе)
export const getAuthData = () => {
    try {
      const userData =  sessionStorage.getItem('user_data');
      if (!userData) return null;
      
      const parsedData = JSON.parse(userData);
      if (!parsedData?.api_session_key) return null;
      
      return parsedData;
    } catch (e) {
      console.error('Error parsing user data:', e);
      return null;
    }
  };
  
  //Проверка аутентификации
  export const isAuthenticated = () => {
    return !!getAuthData();
  };
  
  //Проверка роли админа при доступе к странице
  export const checkAdmin = () => {
    const userData = getAuthData();
    // return userData?.role === 'Admin';
    if (userData.role === 'Admin'){
      return(true)
    }else{
      alert("вы не имеете доступ к странице админа")
      return(false)
    }
  };
  export const checkModerator =()=>{
    const userData = getAuthData();
    if (userData.role==='Admin' || userData.role==='Moderator'){
      return(true)
    }else{
      alert("вы не администратор и не модератор")
      return(false)
    }

  }

  //действия при неавторизированном доступе к странице
export const PrivateRoute = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/" replace />;
};

//попытка пользователя с чужой ролью попасть на страницу админа
export const AdminRoute = () => {
  return checkAdmin() ? <Outlet /> : <Navigate to="/Main_page" replace />;
};
//блокировка страниц модератора и админа
export const ModeratorRoute=()=>{
    return checkModerator() ? <Outlet/>: <Navigate to="/Main_page" replace />
}

//выход на страницу авторизации
export const AuthRoute = () => {
  return !isAuthenticated() ? <Outlet /> : <Navigate to="/Main_page" replace />;
};